const ZaiWebhookIgnoreFilterKeys = ['OrderBy', 'SortBy', 'PageNumber', 'PageSize'];

export default ZaiWebhookIgnoreFilterKeys;
